<template>
    <div :class="preCls + 'container-padding'">
        <div :class="preCls + 'content-box'">
            <div :class="preCls + 'filter'">
                <span :class="preCls + 'filter-label'">所属客户</span>
                <Select v-model="filter.customerId"
                    :class="preCls + 'select-public-style'"
                    transfer clearable
                    @on-change="search">
                    <Option v-for="(item, index) in customerInfoList"
                        :value="item.id"
                        :key="index">
                        {{item.customerName}}
                    </Option>
                </Select>
            </div>
            <table-tool-bar style="margin-top: 16px;">
                <template slot="left">
                    <table-searcher v-model="filter.nickname"
                        placeholder="请输入姓名"
                        style="margin-left: 10px;"
                        @search="search">
                    </table-searcher>
                </template>
                <Button v-if="$can('add')" 
                    :class="preCls + 'button-margin'"
                    :disabled="loading"
                    type="primary"
                    @click="onClickAdd">
                    新增外部用户
                </Button>
            </table-tool-bar>
            <Table ref="mt"
                :columns="columns"
                :data="page.list"
                :loading="loading"
                :height="mtHeight">
                <template v-slot:enabled="{ row }">
                    <i-switch v-model="row.enabled"
                        size="large"
                        :true-value="1"
                        :false-value="0"
                        :readonly="$can('update')"
                        @on-change="changeStatus(row)">
                        <span slot="open">启用</span>
                        <span slot="close">禁用</span>
                    </i-switch>
                </template>
                <!-- 操作列 -->
                <template v-slot:action="{ row }">
                    <Button type="default"
                        size="small"
                        style="margin-right: 5px;"
                        @click="rowClickInfo(row)">
                        详情
                    </Button>
                    <PoptipButton v-if="$can('delete')"
                        text="删除"
                        transfer type="default"
                        style="margin-right: 5px;"
                        title="确认删除该条记录吗?"
                        :ok="() => { rowConfirmDel(row) }">
                    </PoptipButton>
                    <PoptipButton v-if="$can('update')"
                        text="重置密码"
                        transfer type="default"
                        title="重置后密码为123456, 确认重置?"
                        :ok="() => { rowConfirmReset(row) }">
                    </PoptipButton>
                </template>
            </Table>
            <!-- 底部分页 -->
            <table-pager :total.sync="page.total"
                :pageSize.sync="filter.pageSize"
                :pageNo.sync="filter.pageNo"
                @change="fetch">
            </table-pager>
            <!-- 弹出层 -->
            <smart-modal v-model="modal.showCustomer"
                :title="curId ? '客户编辑' : '客户登记'"
                :width="800"
                :height="460"
                :maskClosable="false"
                :buttons.sync="formBtns"
                @close-by-confirm="search">
                <form-customer v-if="modal.showCustomer" :id="curId"></form-customer>
            </smart-modal>
        </div>
    </div>
</template>
<script>
import { mapCell } from '_c/grid/renderCell'
import FormCustomer from './form-customer'
import { 
    customerList, 
    customerUserList, 
    customerUserDelete, 
    customerUserResetPwd 
} from '@/api/customer-manage'
import Enum from '_u/enum'

const PAGE_SIZE = 20

export default {
    name: 'ListCustomer',

    components: {
        FormCustomer
    },

    data() {
        return {
            mtHeight: 360,
            loading: false,
            filter: {
                pageNo: 1,
                pageSize: PAGE_SIZE,
                nickname: '',
                customerId: this.$cache.customerId
            },
            page: {
                total: 0,
                list: []
            },
            customerInfoList: [],
            modal: {
                showCustomer: false
            },
            curId: '',
            formBtns: []
        }
    },

    computed: {
        columns() {
            return [
                {
                    type: 'index',
                    title: '序号',
                    align: 'center',
                    width: 60
                },
                {
                    key: 'customerName',
                    title: '客户',
                    align: 'left',
                    minWidth: 120
                },
                {
                    key: 'nickname',
                    title: '姓名',
                    align: 'left',
                    minWidth: 120
                },
                {
                    key: 'phone',
                    title: '手机号',
                    align: 'left',
                    minWidth: 120
                },
                {
                    key: 'dept',
                    title: '部门',
                    align: 'left',
                    minWidth: 120
                },
                {
                    key: 'position',
                    title: '岗位',
                    align: 'left',
                    minWidth: 120
                },
                {
                    key: 'enabled',
                    title: '启用状态',
                    align: 'center',
                    minWidth: 200,
                    slot: 'enabled'
                },
                {
                    key: 'reportUserName',
                    title: '汇报对象',
                    align: 'left',
                    minWidth: 120
                },
                {
                    key: 'action',
                    title: '操作',
                    align: 'center',
                    width: 200,
                    fixed:"right",
                    slot: 'action'
                }
            ]
        }
    },

    watch: {
        'filter.customerId': function(val) {
            this.$cache.customerId = val
        }
    },

    created() {
        this.fetch()
    },

    mounted() {
        this.afterContainerResize((el, detector) => {
            this.mtHeight =
                detector.windowHeight -
                this.$refs.mt.$el.getBoundingClientRect().top -
                80
        })
    },

    methods: {
        fetch() {
            this.loading = true

            Promise.all([
                customerList({page: 1, pageSize:999}),
                customerUserList(this.filter)
            ])
            .then(args => {
                var [customer, page] = args
                if (customer) {
                    this.customerInfoList = customer.data.page.list
                }
                this.setPageData(page.data)
            })
            .finally(() => {
                this.loading = false
            })
        },

        search() {
            this.filter.pageNo = 1
            this.fetch()
        },

        setPageData(data) {
            this.page.list = data.page.list
            this.page.total = parseInt(data.page.totalCount)
        },

        onClickAdd(e) {
            this.curId = ""
            this.modal.showCustomer = true
        },

        rowClickInfo(row) {
            this.curId = row.id
            this.modal.showCustomer = true
        },

        rowConfirmDel(row) {
            this.loading = true
            customerUserDelete(row.id).then(() => {
               this.$Message.success(this.$t("tips.delete.success"))
            }).finally(() => this.fetch())
        },

        rowConfirmReset(row) {
            customerUserResetPwd(row.id).then(() => {
                this.$Message.success(this.$t("tips.update.success"))
            }).finally(() => this.fetch())
        }
    }
}
</script>
<style lang="less" 
    scoped>
</style>